import React from 'react';
import '../Style/PCBasembly.css'; // Make sure to create this file


const PCBasembly = () => {
  return (
    <div className="pcb-container">
      <div className="pcb-text">
        <h2>PCB Assembly</h2>
        <p style={{ fontSize: '19px', lineHeight: '1.6' ,color:"black"}}>
        With Automotive Devices Solutions, your PCB assembly needs are in expert hands. Our team is dedicated to transforming your innovative designs into reliable, high-performance products. Utilizing advanced SMT, THT, and mixed technology assembly, we excel in handling complex components, including BGA, uBGA, QFN, and fine-pitch parts, ensuring exceptional precision.


Our facility boasts state-of-the-art Juki and Hanwha machines, enabling us to offer both quick-turn prototypes and large-scale production runs. From the initial inspection to the final test, we follow stringent quality control processes using AOI, X-ray, and comprehensive visual inspections. Whether your industry is medical devices, communications, or semiconductors, we deliver solutions tailored to your specifications, ensuring on-time delivery and reliable performance.
        </p>
      </div>
      <div className="pcb-image">
        <img src='/images (1).jpeg' alt="PCB Assembly" />
      </div>
    </div>
  );
};

export default PCBasembly;
